import { useQuery } from "@tanstack/react-query";

export type CompanyType = "services" | "goods" | "both";
export type PrimaryGoal =
  | "get_paid_faster"
  | "reduce_costs"
  | "automate_workflows"
  | "cash_visibility"
  | "manage_subscriptions";
export type RoleProfile = "owner" | "finance_manager" | "accountant" | "collections_agent";
export type FeatureState = "ACTIVE" | "AVAILABLE" | "HIDDEN";

export interface UpsellPrompt {
  featureKey: string;
  message: string;
  targetTier: string;
}

export interface ProfileConfig {
  companyType: CompanyType;
  primaryGoals: PrimaryGoal[];
  hasRecurring: boolean;
  profileCompleted: boolean;
  roleProfile: RoleProfile;
  tier: string;
  navOrder: string[];
  navEmphasis: string[];
  dashboardWidgets: string[];
  featureStates: Record<string, FeatureState>;
  firstAction: string;
  upsellPrompts: UpsellPrompt[];
}

export function useProfileConfig() {
  return useQuery<ProfileConfig>({
    queryKey: ["/api/workspace/profile-config"],
    retry: false,
    staleTime: 60000,
  });
}
